export const picturesSummaryStyles = (theme) => ({
    imagesContainer: {
        marginTop: '16px',
    },
    marginText: {
        marginTop: 15,
        marginBottom: 15,
    }
});